// Us vs them: switches which competitor is compared (tabs and dropdown stay in sync).
if (!customElements.get('us-vs-them')) {
  customElements.define('us-vs-them', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-uvt-select]');
        if (tab) this.select(tab.dataset.uvtSelect);
      });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-uvt-dropdown]')) this.select(event.target.value);
      });
      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-uvt-select]');
        if (!tab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        const tabs = [...this.querySelectorAll('[data-uvt-select]')];
        const next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        next.focus();
        this.select(next.dataset.uvtSelect);
      });
    }

    select(index) {
      this.querySelectorAll('[data-uvt-competitor]').forEach((cell) => { cell.hidden = cell.dataset.uvtCompetitor !== String(index); });
      this.querySelectorAll('[data-uvt-select]').forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.uvtSelect === String(index))));
      const dropdown = this.querySelector('[data-uvt-dropdown]');
      if (dropdown) dropdown.value = String(index);
    }
  });
}
